export const SET_SYSTEM_SPECIFIC_FEATURES = 'SET_SYSTEM_SPECIFIC_FEATURES';